import { ExternalLink, Github, Sparkles, Globe, Mail, MapPin, ShieldCheck } from "lucide-react";
import appConfig from "../config/appConfig";
import "../styles/views/about-view.css";

function AboutView() {
  const { about } = appConfig;
  const channelCount = Object.values(about.contact || {}).filter(Boolean).length;
  const highlightCount = Array.isArray(about.highlights) ? about.highlights.length : 0;

  return (
    <>
      <section className="glass-panel panel-block about-hero">
        <div className="about-hero-glow about-hero-glow-a" />
        <div className="about-hero-glow about-hero-glow-b" />
        <div className="about-hero-content">
          <p className="about-kicker">
            <Sparkles size={14} />
            About
          </p>
          <h2 className="about-title">{about.title}</h2>
          <p className="about-description">{about.description}</p>
          <div className="about-hero-stats">
            <span>
              <ShieldCheck size={14} />
              {highlightCount} highlights
            </span>
            <span>
              <Mail size={14} />
              {channelCount} contact channels
            </span>
          </div>
          <div className="about-hero-pills">
            <span>Freedom.mp3</span>
            <span>Galaxy UI</span>
          </div>
        </div>
      </section>

      <section className="glass-panel panel-block">
        <h3 className="section-title">Contact</h3>
        <div className="about-grid">
          <article className="about-card">
            <div className="about-card-icon">
              <Mail size={16} />
            </div>
            <p className="about-label">Email</p>
            <h4>{about.contact.email}</h4>
          </article>

          <a
            className="about-card about-link-card"
            href={about.contact.website}
            target="_blank"
            rel="noreferrer"
            aria-label="Open Website"
          >
            <div className="about-card-icon">
              <Globe size={16} />
            </div>
            <p className="about-label">Website</p>
            <h4 className="about-link">
              xqsadness
              <ExternalLink size={14} />
            </h4>
          </a>

          <a
            className="about-card about-link-card"
            href={about.contact.github}
            target="_blank"
            rel="noreferrer"
            aria-label="Open GitHub profile"
          >
            <div className="about-card-icon">
              <Github size={16} />
            </div>
            <p className="about-label">GitHub</p>
            <h4 className="about-link">
              xqsadness
              <ExternalLink size={14} />
            </h4>
          </a>

          <article className="about-card">
            <div className="about-card-icon">
              <MapPin size={16} />
            </div>
            <p className="about-label">Location</p>
            <h4>{about.contact.location}</h4>
          </article>
        </div>
      </section>

      <section className="glass-panel panel-block">
        <h3 className="section-title">Highlights</h3>
        <div className="about-highlights">
          {about.highlights.map((item, index) => (
            <article key={item} className="about-highlight">
              <div className="about-highlight-head">
                <span className="about-highlight-index">{String(index + 1).padStart(2, "0")}</span>
                <ShieldCheck size={14} />
              </div>
              <p>{item}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}

export default AboutView;
